module.exports = __webpack_public_path__ + "img/lv.de8d1fc4.svg";